<template>
<transition
  @enter="enter"
  @leave="leave"
  mode="in-out"
>
  <nav class="menu grid">
    <div class="placeholder container" />
    <ul class="menu__wrapper container">
      <li
        v-for="(link, key) in links"
        :key="key"
        class="menu__item"
      >
        <h1>
          <router-link
            :to="link.url"
            v-html="link.text"
            :data-id="key"
            @mouseenter.native="hover"
            @mouseleave.native="hover"
          />
        </h1>
      </li>
    </ul>
    <div class="menu__footer container">
      <ul>
        <li>
          <h6 v-html="'Instagram'"/>
          <a
            href="https://instagram.com/pitokmotormuseum"
            target="_blank"
            rel="noopener"
            class="fx"
          >
            <span><small>@pitokmotormuseum</small></span>
          </a>
        </li>
        <li>
          <h6 v-html="'Dove siamo'"/>
          <a
            href="https://goo.gl/maps/kPAiRcaY7NEjtXpZA"
            target="_blank"
            rel="noopener"
            class="fx"
          >
            <span><small>via porto, 35. san giovanni lupatoto . verona .</small></span>
          </a>
        </li>
        <li>
          <h6 v-html="'Credits'"/>
          <a
            href="https://e-t.studio"
            target="_blank"
            rel="noopener"
            class="fx"
          >
            <span><small>ET.Studio</small></span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</transition>
</template>

<script>
import { TweenMax, Expo } from 'gsap/TweenMax';
import { transition } from '@/animations';

export default {
  name: 'Menu',

  data() {
    return {
      menuAnim: null,
      active: null,
      items: [],
      line: null,
      lineBounding: null,

      links: {
        home: {
          url: '/',
          text: 'Home',
        },
        manifest: {
          url: '/manifesto',
          text: 'Manifesto',
        },
        esposizione: {
          url: '/',
          text: 'Esposizione',
        },
        contact: {
          url: '/contatti',
          text: 'Contatti',
        },
      },
    };
  },

  mounted() {
    if (this.menuAnim === null) this.menuAnim = transition.get('menu')(this.$root.$el);
    this.items = Array.from(this.$el.querySelectorAll('.menu__item a'));
    this.line = document.querySelector('.burger__line');

    this.lineBounding = this.line.getBoundingClientRect();
  },

  methods: {
    hover(event) {
      const dir = event.type === 'mouseenter';

      if (dir) {
        this.active = event.target.dataset.id;

        this.items.forEach((el) => {
          if (el.dataset.id !== event.target.dataset.id) {
            el.classList.add('not-hovered');
          } else {
            el.classList.remove('not-hovered');

            if (window.innerWidth > 1024) {
              const bounding = el.getBoundingClientRect();
              const ratioLineHeight = this.lineBounding.height + (window.innerWidth * 22 / 1920);
              TweenMax.to(this.line, 1.4, {
                y: bounding.top - this.lineBounding.top + parseInt(window.getComputedStyle(el.parentNode).fontSize, 10) - ratioLineHeight,
                ease: Expo.easeOut,
              });
            }
          }
        });
      } else {
        this.active = null;
        this.items.forEach(el => el.classList.remove('not-hovered'));

        if (window.innerWidth > 1024) {
          TweenMax.to(this.line, 1, {
            y: 0,
            ease: Expo.easeOut,
          });
        }
      }
    },

    enter(el, done) {
      this.menuAnim
        .eventCallback('onComplete', done)
        .play();
    },

    leave(el, done) {
      this.menuAnim
        .eventCallback('onReverseComplete', done)
        .reverse();
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: 2;

  justify-content: space-between;
  pointer-events: none;

  .container {
    // grid-column-end: 33;
    // background: $color-black;
  }

  h1 {
    line-height: 1em;
    margin: 0;
    a {
      padding: 0 0 0.75em 0;

      @include mq(ipadP) {
        padding: 0 0 0.5em 0;
      }
    }
  }

  .placeholder {
    min-height: 0px;
  }

  &__wrapper {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;

    pointer-events: auto;

    @include mq($until: ipadP) {
      padding-top: 40px;
    }
  }

  &__item {
    a {
      display: inline-block;
      transition: opacity 0.2s ease-out 0.1s;

      &:hover {
        opacity: 1;
      }

      &.not-hovered {
        opacity: 0.1;
      }
    }
  }

  &__footer {
    pointer-events: auto;

    display: flex;
    align-items: center;

    ul {
      display: flex;
      flex-flow: row wrap;

      li {
        &:not(:first-child) {
          margin-top: rem(40px);

          @include mq(ipadP) {
            margin-left: rem(100px);
            margin-top: 0;
          }
        }
      }

      h6 {
        margin: 0 0 0.5em 0;

        @include mq(ipadP) {
          // margin: 0 0 1em 0;
        }
      }
    }

    @include mq($until: ipadP) {
      display: flex;
      align-items: flex-end;
      padding: rem(50px) 0;
    }
  }
}
</style>
